export enum ServiceType {
    PIZZA = 'PIZZA',
    TURKISH = 'TURKISH',
    BUTCHER = 'BUTCHER',
    AUSTRIAN = 'AUSTRIAN',
    PASTA = 'PASTA',
}
